import React, { useEffect, useRef, useState } from 'react';
import { showToast } from '../../../utils';

interface Option { value: string | number; label: string; }

interface FilterDropdownProps {
    icon: React.ReactNode;
    placeholder?: string;
    options: Option[];
    value?: string | number | null;
    onChange: (value: any) => void;
    disabled?: boolean;
    disabledMessage?: any
}

const FilterDropdown = ({ icon, placeholder = 'Select', options = [], value, onChange, disabled = false, disabledMessage = '' }: FilterDropdownProps) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const selected = options.find((o) => o.value === value);

    useEffect(() => {
        const close = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, []);

    return (
        <div className={`fd ${open ? 'fd--open' : ''}`} ref={ref}>
            <button
                type="button"
                className="fd__trigger"
                onClick={() => {
                    if (disabled && disabledMessage) {
                        showToast(disabledMessage, 'error')
                        return
                    }
                    setOpen((p) => !p)
                }}
            >
                <span className="fd__icon">{icon}</span>
                <span className="fd__label">{selected?.label || placeholder}</span>
                <svg className="fd__chevron" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>

            {open && (
                <ul className="fd__menu">
                    {options.map((opt) => (
                        <li
                            key={opt.value}
                            className={`fd__option ${opt.value === value ? 'fd__option--active' : ''}`}
                            onClick={() => { onChange(opt); setOpen(false); }}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default FilterDropdown;